<style scoped lang="stylus">
    @import '../../../assets/css/theme.styl'
    .order-filter {
        .van-popup--right {
            width 100%
            height: 100vh
            box-sizing border-box
            padding 20px 10px
        }
        .van-popup {
            background-color: baseBackColor
        }
    }
</style>

<template>
    <div class="order-filter cus-cell">
        <van-popup v-model="popShow" position="right">
            <van-field
                    readonly
                    clickable
                    clearable
                    label="厂区"
                    :value="factoryName"
                    placeholder="厂区"
                    @click="facPicker = true"
                    v-show="!isFactory"
            />

            <van-field
                    readonly
                    clickable
                    clearable
                    label="卡口"
                    :value="kaName"
                    placeholder="卡口"
                    @click="kaPicker = true"
            />
            <van-field
                    label="车牌号"
                    v-model="searchForm.plate_number"
                    placeholder="车牌号"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="开始时间"
                    :value="startTime"
                    placeholder="开始时间"
                    @click="startTimePicker = true"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="结束时间"
                    :value="endTime"
                    placeholder="结束时间"
                    @click="endTimePicker = true"
            />

            <van-field
                    readonly
                    clickable
                    clearable
                    label="核验人"
                    :value="check_op"
                    placeholder="核验人"
                    @click="kaAdminPicker = true"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="核验状态"
                    :value="check_status"
                    placeholder="核验状态"
                    @click="statePicker = true"
            />

            <div class="bt-cus-box">
                <van-button type="primary" size="large" @click="searchSubmit">确 定</van-button>
                <van-button type="warning" size="large" @click="resetSearch">重 置</van-button>
                <van-button type="default" size="large" @click="hide">取 消</van-button>
            </div>
        </van-popup>

        <van-popup v-model="facPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择厂区"
                    :columns="facColumns"
                    @cancel="hideFac"
                    @confirm="facConfirm"
            />
        </van-popup>

        <van-popup v-model="kaPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择卡口"
                    :columns="kaColumns"
                    @cancel="hideKa"
                    @confirm="kaConfirm"
            />
        </van-popup>

        <van-popup v-model="startTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="startTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="startTimeConfirm"
                    @cancel="hideStartTime"
            />
        </van-popup>

        <van-popup v-model="endTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="endTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="endTimeConfirm"
                    @cancel="hideEndTime"
            />
        </van-popup>

        <van-popup v-model="kaAdminPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择核验人"
                    :columns="kaAdminColumns"
                    @cancel="hideKaAdmin"
                    @confirm="kaAdminConfirm"
            />
        </van-popup>

        <van-popup v-model="statePicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="核验状态"
                    :columns="stateColumns"
                    @cancel="hideState"
                    @confirm="stateConfirm"
            />
        </van-popup>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import {getListNp as getKaListNp} from "@/service/ka";
    import {getListNp as getFacListNp} from "@/service/fac";
    import { getListNp as getKaAdminList } from "@/service/kaUser";
    import { CHECK_STATE } from "@/config";
    import _ from 'lodash'

    export default {
        props: [
            'isFactory'
        ],
        components: {},
        data() {
            return {
                checkState: CHECK_STATE,
                popShow: false,

                facPicker: false,
                kaPicker: false,
                startTimePicker: false,
                endTimePicker: false,
                kaAdminPicker: false,
                statePicker: false,

                startTime: '',
                endTime: '',
                startTimeDate: dayjs().toDate(),
                endTimeDate: dayjs().toDate(),
                maxDate: dayjs().endOf('day').toDate(),

                factoryName: '',
                kaName: '',
                check_status: '',
                check_op: '',

                facList: [],
                kaList: [],
                kaAdminList: [],
                stateList: CHECK_STATE,

                facColumns: [],
                kaColumns: [],
                kaAdminColumns: [],
                stateColumns: [],


                searchForm: {
                    plate_number: '',
                    check_status: '',
                    check_op: '',
                    factory_id: '',
                    kakou_no: '',
                    settlement_time: '',
                }
            };
        },
        created() {
            this.getFacList()
            this.getKaList()
            this.getKaAdminList()
            this.setStateColumns()
        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {
            show(isQuickType) {
                if (isQuickType) {
                    this.startTime = ''
                    this.endTime = ''
                }
                this.popShow = true
            },
            hide() {
                this.popShow = false
            },

            setStateColumns() {
                this.stateColumns = _.map(CHECK_STATE, item => {
                    return item
                })
            },
            resetSearch() {
                this.resetTime()
                this.searchForm.factory_id = ''
                this.factoryName = ''
                this.searchForm.kakou_no = ''
                this.kaName = ''
                this.check_op = ''
                this.searchForm.check_op = ''
                this.check_status = ''
                this.searchForm.check_status = ''
                this.searchForm.plate_number = ''
            },
            resetTime() {
                this.searchForm.settlement_time = ''
                this.startTime = ''
                this.endTime = ''
            },
            kaConfirm(val, index) {
                this.kaName = val
                this.searchForm.kakou_no = this.kaList[index].kakou_no
                this.hideKa()
            },

            searchSubmit() {
                if (this.startTime != '' || this.endTime != '') {
                    if (this.startTime == '') {
                        this.$toast('开始时间不能为空')
                        return
                    }
                    if (this.endTime == '') {
                        this.$toast('结束时间不能为空')
                        return
                    }
                    if (dayjs(this.startTimeDate).isAfter(dayjs(this.endTimeDate))) {
                        this.$toast('开始结束时间不正确')
                        this.searchForm.settlement_time = ''
                        return
                    }
                    this.searchForm.settlement_time = `${this.startTime} - ${this.endTime}`
                }

                // this.search()
                this.$emit('filter-change', this.searchForm)
                this.hide()
            },

            async getFacList() {
                let res = await getFacListNp()
                if (res.status) {
                    this.facList = res.data
                    this.facColumns = this.facList.map(item => {
                        return item.factory_name
                    })
                }
            },
            async getKaList() {
                let res = await getKaListNp()
                if (res.status) {
                    this.kaList = res.data
                    this.kaColumns = this.kaList.map(item => {
                        return item.kakou_name
                    })
                }
            },
            async getKaAdminList() {
                let res = await getKaAdminList()
                if (res.status) {
                    this.kaAdminList = res.data
                    this.kaAdminColumns = this.kaAdminList.map(item => {
                        return item.name
                    })
                }
            },


            facConfirm(val, index) {
                this.factoryName = val
                this.searchForm.factory_id = this.facList[index].id
                this.hideFac()
            },
            kaConfirm(val, index) {
                this.kaName = val
                this.searchForm.kakou_no = this.kaList[index].kakou_no
                this.hideKa()
            },
            hideFac() {
                this.facPicker = false
            },
            hideKa() {
                this.kaPicker = false
            },

            startTimeConfirm(val) {
                this.startTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.hideStartTime()
            },
            hideStartTime() {
                this.startTimePicker = false
            },
            hideEndTime() {
                this.endTimePicker = false
            },
            endTimeConfirm(val) {
                this.endTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.hideEndTime()
            },

            kaAdminConfirm(val, index) {
                this.check_op = val
                this.searchForm.check_op = this.kaAdminList[index].id
                this.hideKaAdmin()
            },
            hideKaAdmin() {
                this.kaAdminPicker = false
            },

            hideState() {
                this.statePicker = false
            },
            stateConfirm(val, index) {
                this.check_status = val
                this.searchForm.check_status = _.findKey(CHECK_STATE, o => {return o == val})
                this.hideState()
            },
        },
    };
</script>
